<template>
    <div class="large-3 medium-6 small-6 column m-b-5">
        <div class="chart br dropshadow-small">
            <div class="chart-content p-4 p-t-5 p-b-5">
                <div class="chart-meta row row-collapse">
                    <div class="column">
                        <p class="f-s-4 c-medium-tint m-b-2">{{ metric.name }}</p>
                    </div>
                    <div class="i-container i-tone-accent fl-right">
                        <metric-icon v-bind:type="metric.icon"></metric-icon>
                    </div>
                </div>
                <div class="chart-header">
                    <h4 class="chart-title c-primary f-s-10 f-w-regular m-b-3 ">{{ metric.value }}</h4>
                    <div v-if="period !== 'all-time'">
                        <span v-if="metric.trend === '-'" class="c-error-bg c-bright chart-stat-group inline rounded-xlarge m-r-2">
                            <span class="i-container i-filled-bright">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="injected-svg icon inject-svg i-size-small"><g fill="none" fill-rule="evenodd"><path d="M24 24H0V0h24z"></path><path fill="#000" class="icon" d="M7 10l5 6 5-6z"></path></g></svg>
                            </span>
                            <span class="chart-stat-value c-bright f-s-2 inline m-t-micro m-n-l-micro m-r-micro">{{ metric.difference }}%</span>
                        </span>
                        <span v-else-if="metric.trend === '+'" class="c-theme-bg c-bright chart-stat-group inline rounded-xlarge m-r-2">
                            <span class="i-container i-filled-bright">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="injected-svg icon inject-svg i-size-small"><path fill="none" d="M0 0h24v24H0z"></path><path class="icon" d="M17 14l-5-6-5 6z"></path></svg>
                            </span>
                            <span class="chart-stat-value c-bright f-s-2 inline m-t-micro m-n-l-micro m-r-micro">{{ metric.difference }}%</span>
                        </span>
                        <span v-else class="c-muted-bg c-bright chart-stat-group inline rounded-xlarge m-r-2">
                            <span class="i-container i-filled-bright">
                                <span class="i-size-small inline text-center">-</span>
                            </span>
                            <span class="chart-stat-value c-bright f-s-2 inline m-t-micro m-n-l-micro m-r-micro">{{ metric.difference }}%</span>
                        </span>
                        <span class="chart-help-text c-muted f-s-2">{{ trans('from :period', {'period': previousPeriod}) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MetricIcon from './MetricIcon.vue';

export default {
    components: {
        MetricIcon,
    },
    props: {
        metric: {
            type: Object,
            required: true
        },
        period: {
            type: String,
            default: 'today'
        },
    },
    computed: {
        previousPeriod() {
            switch (this.period) {
                case 'today':
                    return this.trans('yesterday');
                case 'month':
                    return this.trans('last month');
                case 'year':
                    return this.trans('last year');
                default:
                    return '';
            }
        },
    },
}
</script>